function hashCode(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return hash
}

function intToRGB(i: number): string {
  const c = (i & 0x00ffffff).toString(16).toUpperCase()

  return '00000'.substring(0, 6 - c.length) + c
}

function luminance(r: number, g: number, b: number): number {
  const a = [r, g, b].map(function (v) {
    v /= 255
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  })
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722
}

export function isLightColor(color: string) {
  if (color.startsWith('#')) color = color.substring(1)
  const r = parseInt(color.slice(0, 2), 16)
  const g = parseInt(color.slice(2, 4), 16)
  const b = parseInt(color.slice(4, 6), 16)
  const bgLuminance = luminance(r, g, b)
  const whiteLuminance = luminance(255, 255, 255)
  const contrastRatio = (whiteLuminance + 0.05) / (bgLuminance + 0.05)
  return contrastRatio < 3.5
}

export function getBackgroundColor(initials = 'NI'): string {
  const whiteLuminance = luminance(255, 255, 255)

  let contrastRatio = 0
  let color = ''
  let attemptsLeft = 50
  while (contrastRatio < 4.5 && attemptsLeft > 0) {
    const seed = hashCode(initials)
    color = intToRGB(seed)
    const r = parseInt(color.slice(0, 2), 16)
    const g = parseInt(color.slice(2, 4), 16)
    const b = parseInt(color.slice(4, 6), 16)
    const bgLuminance = luminance(r, g, b)
    contrastRatio = (whiteLuminance + 0.05) / (bgLuminance + 0.05)
    // Modify initials to change the hash value in a consistent way
    initials += initials
    attemptsLeft--
  }

  return `#${color}`
}
